import get from 'transmute/get';
import { DISMISSED_AT, VIEWED_COUNT } from '../constants/userPromptDataKeyPaths';
export const getViewedCount = get(VIEWED_COUNT);
export const getDismissedAt = get(DISMISSED_AT);